export var SignatureFormat = /*#__PURE__*/ function(SignatureFormat) {
    SignatureFormat["TEXT"] = "text/plain";
    SignatureFormat["POINTS"] = "points/json";
    return SignatureFormat;
}({});
export var SignatureMode = /*#__PURE__*/ function(SignatureMode) {
    SignatureMode["DRAW"] = "draw";
    SignatureMode["TYPE"] = "type";
    SignatureMode["UPLOAD"] = "upload";
    return SignatureMode;
}({});
export var SignatureView = /*#__PURE__*/ function(SignatureView) {
    SignatureView["DRAW"] = "draw";
    SignatureView["TYPE"] = "type";
    SignatureView["IMAGE"] = "image";
    SignatureView["UPLOAD"] = "upload";
    return SignatureView;
}({});

//# sourceMappingURL=signature-types.js.map